import classnames from 'classnames'
import Icon from '@components/Icon'
import Button from '@components/Button'
import { AppStoreBadge, GooglePlayStoreBadge } from '@components/AppDownloadBadge'

import styles from '../styles.module.scss'

const SuccessPage = ({ href = '/dashboard/subscriptions' }) => (
    <div className="mx-auto text-center">
        <Icon type="check-circle" size="xl" />
        <h4 className="mt-6">
            <T>subscription.purchase.success.thank.you</T>
        </h4>
        <p className="mt-5">
            <T>subscription.purchase.success.description</T>
        </p>
        <Button btnStyle="primary" className={classnames('my-4', 'mx-auto', styles.redirectButton)} href={href}>
            <T>subscription.purchase.success.btn.manage</T>
        </Button>
        <p className="mt-5">
            <T>subscription.purchase.success.download.app</T>
        </p>
        <div className="d-flex justify-content-center mt-4 mb-5">
            <AppStoreBadge linkClass={styles.appLogos} imgClass={classnames('mr-4', styles.appLogos)} />
            <GooglePlayStoreBadge linkClass={styles.appLogos} imgClass={styles.appLogos} />
        </div>
    </div>
)
export default SuccessPage
